<style scoped>
.prize-product-info-modal ::v-deep .modal-window {
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 8rem);
}

.prize-product-info-modal ::v-deep .product-image-wrapper {
    max-width: 70%;
}

.prize-product-info-modal ::v-deep .product-info {
    overflow-y: auto;
}

@screen sm {
    .prize-product-info-modal ::v-deep .modal-window {
        max-height: calc(100vh - 4rem);
    }

    .prize-product-info-modal ::v-deep .product-info-wrapper {
        overflow-y: auto;
    }

    .prize-product-info-modal ::v-deep .product-image-wrapper {
        max-width: 100%;
    }
}
</style>

<template>
    <div class="flex flex-col items-center">
        <div class="w-full">
            <imageLoader
                :src="imgBanner"
                :srcError="tinyBlankGifImg"
                :ratio="1200 / 200"
            />
        </div>
        <div v-if="true" class="flex flex-col items-center mt-4 w-full">
            <div class="w-full max-w-3xl">
                <promotionEventPrizeCarousel
                    v-if="carouselPrizes.length"
                    :title="'今期的獎品包括'"
                    :list="carouselPrizes"
                    @clickPrize="({ prize }) => (previewPrize = prize)"
                />
                <modal
                    type="custom"
                    v-if="!!previewPrize"
                    :showDismiss="true"
                    class="prize-product-info-modal modal-3xl"
                    @backdrop="previewPrize = undefined"
                >
                    <productInfo
                        class="product-info"
                        :product="previewPrize"
                        :productLinks="productLinks(previewPrize)"
                        :showProdDespImg="true"
                    >
                        <template v-if="false" #button>
                            <router-link
                                tag="button"
                                class="btn py-1 px-4 text-secondary bg-white border-secondary"
                                :to="
                                    previewCmpyToken
                                        ? {
                                              name: 'previewProduct',
                                              params: {
                                                  cmpyToken: previewCmpyToken,
                                                  id: product.id
                                              }
                                          }
                                        : {
                                              name: 'product',
                                              params: { id: product.id }
                                          }
                                "
                            >
                                <div
                                    class="flex flex-row items-center justify-center w-full text-sm"
                                >
                                    <div class="icon">
                                        <eyeSvg />
                                    </div>
                                    <div class="px-2 text-center">
                                        {{ '了解更多' }}
                                    </div>
                                </div>
                            </router-link>
                        </template>
                    </productInfo>
                </modal>
            </div>
        </div>
        <div class="flex flex-col items-center mt-4 p-4">
            <template v-if="isEventStarted && !isEventClosed">
                <msgSlot
                    msgKey="您有{0}次抽獎機會"
                    class="flex items-center text-3xl font-bold mt-2"
                >
                    <template #slot0>
                        <div class="text-primary">
                            {{ custTknCnt }}
                        </div>
                    </template>
                </msgSlot>
                <button
                    class="btn btn-primary text-3xl px-16 py-4 mt-2"
                    @click="showModal = true"
                    :disabled="isEventClosed || !custTknCnt"
                >
                    {{ !isEventClosed ? '立即抽獎' : '活動已結束' }}
                </button>
                <luckyDrawModal
                    v-if="showModal"
                    @hide="showModal = false"
                    :promotionEventId="eventId"
                />
                <router-link
                    tag="button"
                    :to="{ name: 'promotionEventHistory' }"
                    class="text-secondary text-lg border-b border-secondary mt-4"
                >
                    {{ '查看得獎紀錄' }}
                </router-link>
            </template>
            <template v-else>
                <div class="text-3xl my-8">
                    {{ '活動即將開始！' }}
                </div>
            </template>
        </div>
        <div class="flex flex-col items-center max-w-2xl mt-4">
            <div class="text-xl font-bold">
                {{ `${event.prmtEvntName}活動說明` }}
            </div>
            <contentNewLine class="mt-2" :value="event.prmtEvntDesp" />
            <a
                :href="termsAndConditionsFilePath"
                target="_blank"
                class="mr-auto mt-2 underline text-sm text-blue"
            >
                {{ '活動條款及細則' }}
            </a>
        </div>
    </div>
</template>

<script>
import luckyDrawModal from '../../components/luckyDrawModal.vue';
import msgSlot from '../../components/msgSlot';
import ctx from '../../utils/ctx';
import imageLoader from '../../components/imageLoader.vue';
import contentNewLine from '../../components/contentNewLine';
import modal from '../../components/modal.vue';
import productInfo from '../../components/productInfo.vue';
import promotionEventPrizeCarousel from '../../components/promotionEventPrizeCarousel.vue';

export default {
    components: {
        luckyDrawModal,
        msgSlot,
        imageLoader,
        contentNewLine,
        modal,
        productInfo,
        promotionEventPrizeCarousel
    },
    data() {
        return {
            tinyBlankGifImg:
                'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
            showModal: false,
            eventId: this.$route.params.eventId,
            previewPrize: undefined
        };
    },
    methods: {
        clickPrizeImage(prize) {
            this.previewPrize = prize;
        }
    },
    computed: {
        event() {
            return (this.$store.state.promotionEvents || []).find(
                p => p.prmtEvntId === this.eventId
            );
        },
        prizes() {
            return this.event?.prmtEvntPrzList || [];
        },
        carouselPrizes() {
            return this.prizes.filter(
                p => p.prodKey && p.prmtEvntPrzDispInd === 'Y'
            );
        },
        productLinks() {
            return prize =>
                (this.event.prodLinkList || []).filter(
                    pl => pl.prodKey === prize.prodKey
                );
        },
        custTknCnt() {
            return this.event?.custTknCnt || 0;
        },
        imgBanner() {
            return ctx(`/eventImage/${this.eventId}_banner.png`);
        },
        termsAndConditionsFilePath() {
            return ctx(`/eventTermsAndConditions/${this.eventId}.pdf`);
        },
        eventEndDate() {
            return this.event?.prmtEvntEndDate;
        },
        eventActivityBeginDate() {
            return this.event?.prmtEvntActvBgnDate;
        },
        isEventStarted() {
            return !this.$store.getters.isBeforePromotionEventActivityBeginDate(
                this.event
            );
        },
        isEventClosed() {
            return this.$store.getters.isAfterPromotionEventEndDate(this.event);
        }
    }
};
</script>
